/**
 * API client for Portero GPS module
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

const PORTERO_TOKEN_KEY = 'portero_token';
const PORTERO_USER_KEY = 'portero_user';

function getToken() {
  return localStorage.getItem(PORTERO_TOKEN_KEY);
}

function headers() {
  return {
    'Authorization': `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  };
}

async function handleResponse(r) {
  if (r.status === 401) {
    localStorage.removeItem(PORTERO_TOKEN_KEY);
    localStorage.removeItem(PORTERO_USER_KEY);
    window.location.href = '/portero';
    throw new Error('Sesión expirada');
  }
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error(body.detail || `Error ${r.status}`);
  }
  return r.json();
}

// Auth
export const porteroLogin = async (email, password) => {
  const resp = await fetch(`${API_URL}/api/portero/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await handleResponse(resp);
  localStorage.setItem(PORTERO_TOKEN_KEY, data.access_token);
  localStorage.setItem(PORTERO_USER_KEY, JSON.stringify(data.user));
  return data;
};

export const porteroLogout = () => {
  localStorage.removeItem(PORTERO_TOKEN_KEY);
  localStorage.removeItem(PORTERO_USER_KEY);
};

export const getPorteroUser = () => {
  try {
    return JSON.parse(localStorage.getItem(PORTERO_USER_KEY));
  } catch { return null; }
};

export const isPorteroAuth = () => !!getToken();

export const porteroMe = () =>
  fetch(`${API_URL}/api/portero/auth/me`, { headers: headers() }).then(handleResponse);

// Devices
export const getDispositivos = () =>
  fetch(`${API_URL}/api/portero/dispositivos`, { headers: headers() }).then(handleResponse);

// Buttons
export const getMisBotones = () =>
  fetch(`${API_URL}/api/portero/botones`, { headers: headers() }).then(handleResponse);

// Send command
export const enviarComando = (device_id, command, boton_nombre) =>
  fetch(`${API_URL}/api/portero/comando`, {
    method: 'POST', headers: headers(),
    body: JSON.stringify({ device_id, command, boton_nombre }),
  }).then(handleResponse);

// Log
export const getLog = (limit = 50) =>
  fetch(`${API_URL}/api/portero/log?limit=${limit}`, { headers: headers() }).then(handleResponse);

// Admin
export const adminGetUsuarios = () =>
  fetch(`${API_URL}/api/portero/admin/usuarios`, { headers: headers() }).then(handleResponse);

export const adminCrearUsuario = (data) =>
  fetch(`${API_URL}/api/portero/admin/usuarios`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const adminEditarUsuario = (id, data) =>
  fetch(`${API_URL}/api/portero/admin/usuarios/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const adminGetDispositivosUsuario = (userId) =>
  fetch(`${API_URL}/api/portero/admin/usuarios/${userId}/dispositivos`, { headers: headers() }).then(handleResponse);

export const adminGetConfig = (userId) =>
  fetch(`${API_URL}/api/portero/admin/config/${userId}`, { headers: headers() }).then(handleResponse);

export const adminSetConfig = (userId, deviceId, data) =>
  fetch(`${API_URL}/api/portero/admin/config/${userId}/${deviceId}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const adminDeleteConfig = (userId, deviceId) =>
  fetch(`${API_URL}/api/portero/admin/config/${userId}/${deviceId}`, {
    method: 'DELETE', headers: headers(),
  }).then(handleResponse);
